/**
 * #199: the date handling the order, invoice and blog filters used to repeat — twelve copies of
 * the query formatting, four of the default range, three of `withoutTime`.
 */

/** Midnight at the start of the same local day; the argument is not changed. */
export function startOfDay(date: Date): Date {
  const day = new Date(date.getTime());
  day.setHours(0, 0, 0, 0);
  return day;
}

/** The default period of the list filters: from `days` ago until today, both at midnight. */
export function defaultDateRange(days = 180): { from: Date; to: Date } {
  const from = new Date();
  from.setDate(from.getDate() - days);
  return { from: startOfDay(from), to: startOfDay(new Date()) };
}

/**
 * A filter date as the BFF's search endpoints take it: the **local** calendar day, sent as
 * midnight UTC (`2026-10-04T00:00:00Z`), or `''` for no date. That is what
 * `DatePipe.transform(d, "yyyy-MM-dd'T00:00:00Z'")` produced: the day the user picked, not
 * the instant — a German user's 4 October stays the 4th instead of becoming the 3rd at 22:00Z.
 */
export function toApiDate(date?: Date | null): string {
  if (!date) {
    return '';
  }
  const year = String(date.getFullYear()).padStart(4, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00Z`;
}
